module.exports = __webpack_public_path__ + "static/media/10n.6ba6e4a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/10n.svg
// module id = 157
// module chunks = 0